import { useLocalStorage } from '@mantine/hooks';
import { useCallback } from 'react';
import { Flags } from './FlagsHook';

export default function useFlagOverrides() {
  const [overrides, setOverrides] = useLocalStorage<Partial<Flags>>({
    key: 'dev-flag-overrides',
    defaultValue: {},
    getInitialValueInEffect: false,
  });

  const setOverride = useCallback(
    (key: keyof Flags, value: boolean) => {
      setOverrides(prev => ({ ...prev, [key]: value }));
    },
    [setOverrides],
  );

  const clearOverride = useCallback(
    (key: keyof Flags) => {
      setOverrides(prev => {
        const next = { ...prev };
        delete next[key];
        return next;
      });
    },
    [setOverrides],
  );

  const clearAll = useCallback(() => {
    setOverrides({});
  }, [setOverrides]);

  const hasOverrides = Object.keys(overrides).length > 0;

  return { overrides, setOverride, clearOverride, clearAll, hasOverrides };
}
